export const RESET = 'EXCMDEVICESTATE_LIST_RESET'
export const SET_ITEMS = 'EXCMDEVICESTATE_LIST_SET_ITEMS'
export const SET_ERROR = 'EXCMDEVICESTATE_LIST_SET_ERROR'
export const SET_VIEW = 'EXCMDEVICESTATE_LIST_SET_VIEW'
export const TOGGLE_LOADING = 'EXCMDEVICESTATE_LIST_TOGGLE_LOADING'
